<prcins-mobile-app
  [allowWebContinue] = false
>
</prcins-mobile-app>
